'use strict';

import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

Swiper.use([Navigation, A11y, Keyboard]);

export default class OPLSwiper {

    initSwiper(carouselEl, config) {
        if (carouselEl && config) {
            new Swiper(carouselEl, config);
        }
    }

}
